import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { Flex } from "../../../../flex";

export const P2PCarrierInput = groupInput({
  apiKey: input<string>({ validator: nonEmptyValidator }),
  customerId: input<string>({ validator: nonEmptyValidator }),
  username: input<string>({ validator: nonEmptyValidator }),
});

export type P2PCarrierValue = InputSchema.Value<typeof P2PCarrierInput>;

export type P2PCarrierForm = InputSchema.Input<typeof P2PCarrierInput>;

export const p2pCarrierDefault = (): P2PCarrierValue => ({
  apiKey: "",
  customerId: "",
  username: "",
});

export const CreateP2PCarrierForm = memo(function CreateP2PCarrierForm({
  carrierInput,
}: {
  carrierInput: P2PCarrierForm;
}) {
  return (
    <Flex dir="column">
      <RedoTextInput
        inputTypeHint="password"
        label="API key"
        placeholder=""
        setValue={carrierInput.inputs.apiKey.setValue}
        value={carrierInput.inputs.apiKey.value}
      />
      <RedoTextInput
        label="Customer ID"
        placeholder=""
        setValue={carrierInput.inputs.customerId.setValue}
        value={carrierInput.inputs.customerId.value}
      />
      <RedoTextInput
        label="Username"
        placeholder=""
        setValue={carrierInput.inputs.username.setValue}
        value={carrierInput.inputs.username.value}
      />
    </Flex>
  );
});
